import React, { useContext } from "react";
import { LocaleContext } from "../contexts";
function SelectionIndicator(props) {
  var _props$count = props.count,
    count = _props$count === void 0 ? 0 : _props$count;
  var locale = useContext(LocaleContext);
  var template = count === 1 ? locale.selectedItem : locale.selectedItems;
  var content = template.replace(/\$count/, "".concat(count));
  return count > 0 ? /*#__PURE__*/React.createElement("div", {
    className: "list-selection-indicator"
  }, content) : null;
}
export default SelectionIndicator;